'use strict';

(function () {
  angular
    .module('specsguardApp')
    .config(pveTemplate);

  pveTemplate.$inject = ['$stateProvider'];

  function pveTemplate (stateProvider) {
    stateProvider

      .state('pve_template', {
        url: '/pve_template',
        templateUrl: 'app-legacy/components/sg-template-list/sg-template-list.html',
        controller: 'TemplateListCtrl',
        controllerAs: '$TemplateListCtrl',
        menu: {
          context: 'textual_template',
          title: '[Textual_templates]',
          subtitle: '[project_templates]',
          icon: 'folder_empty'
        },
        authenticate: true,
        params: {
          projectLevel: 1,
        },
        needRole: 7,
        resolve: {
          templates: ['PvETemplateAPI', function (PvETemplateAPI) {
            return PvETemplateAPI.query({}).$promise;
          }]
        }
      })

      .state('pve_template_detail', {
        url: '/pve_template/{templateId:string}',
        templateUrl: 'app-legacy/components/sg-template-detail/sg-template-detail.html',
        controller: 'sgTemplateDetail',
        menu: {
          context: 'textual_template',
          title: '[project_templates]',
          subtitle: '[TemplateName]',
          icon: 'folder_empty'
        },
        authenticate: true,
        needRole: 7,
        params: {
          templateType: 'pveTemplate',
          projectLevel: 1
        },
        resolve: {
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }],
          template: ['PvETemplateAPI', '$stateParams', function (PvETemplateAPI, $stateParams) {
            return PvETemplateAPI.get({ id: $stateParams.templateId }).$promise;
          }],
          elements: ['LibElement', function (LibElement) {
            return LibElement.getAll({ projectLevel: 1 }).$promise;
          }],
          modules: ['Module', function (Module) {
            return Module.get({}).$promise;
          }],
          areaTemplates: [function () {
            return Promise.resolve(null);
          }],
        }
      });
  }
})();
